import React, { Component, Fragment } from 'react';
import Measure from 'react-measure';
import cx from 'classnames';
import debounce from 'lodash.debounce';
import Bootstrap from '../../tools/Bootstrap';

import InputTooltip from '../InputTooltip';

import analyticsTracker from '../../tools/Tracker';
import Modal from '../../elements/Modal';
import ModalCloseButton from '../../elements/Modal/CloseButton';
import Headline from '../../elements/Headline';
import Input from '../../elements/Form/Input';
import Label from '../../elements/Form/Label';
import Layout from '../../elements/Layout/Container';
import Button from '../../elements/Form/Button';
import ButtonDistorted from '../../elements/Button/Distorted';
import ConfirmActionButton from '../../elements/Form/ConfirmActionButton';
import FormErrorMessage from '../../elements/Form/ErrorMessage';

import API from '../../tools/API';

import './Styles.css';

import iconLogo from '../../images/backmomente-logo2.png';
// import iconMuffin from '../../images/icon-muffin.svg';

import iconReport from '../../images/icon-report.svg';

const REGISTER_BOX_COLLAPSE_BREAKPOINT = 992;
const MOBILE_BREAKPOINT = 1200;

class SignInUpOverlay extends Component {
  state = {
    errors: {},
    errorMessages: {},
    loading: true,
    success: false,
    loginErrorShown: false,
    isRegisterSubmitLoading: false,
    referrerUsername: '',
    has8Chars: false,
    hasOneUpperChar: false,
    hasOneLowerChar: false,
    hasNumber: false,
    hasNoSpecialChars: false,
    hasInputedPassword: false,
    screenWidth: window.innerWidth,
    registerAdditionalInfoSectionHeight: null,
    registerAdditionalInfoSectionOpen: false,
  }

  static getDerivedStateFromProps(props) {
    const { open } = props;
    if (open) {
      document.documentElement.style.overflowY = document.body.style.overflowY = 'hidden';
    } else {
      document.documentElement.style.overflowY = document.body.style.overflowY = 'initial';
    }

    return {};
  }

  _onResize = debounce(() => {
    this.setState({ screenWidth: window.innerWidth });
    if (window.innerWidth > REGISTER_BOX_COLLAPSE_BREAKPOINT) {
      this.setState({ registerAdditionalInfoSectionOpen: true });
    }
  }, 250)

  componentDidMount() {
    const { invitationToken } = this.props;
    if (invitationToken) {
      API.fetchInvitationTokenUsername(invitationToken).then((res) => {
        if (res.success) {
          this.setState({ referrerUsername: res.user_name });
        }
      });
    }
    window.addEventListener('resize', this._onResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._onResize, false);
  }

  setLoginErrorShown = (loginErrorShown, cb) => {
    if (loginErrorShown && this._toolTipTimeout) {
      clearTimeout(this._toolTipTimeout);
    }
    this.setState({ loginErrorShown }, cb);
  }

  onClose = (closeFormWithoutLogin) => {
    const {
      replace,
    } = this.props;
    const {
      signinupModalAllowClose,
      toggleSignInUpModal,
      setSigninupModalAllFieldsRequired,
    } = this.props;

    if (!signinupModalAllowClose && closeFormWithoutLogin) {
      replace('/');
      toggleSignInUpModal();
      return;
    }

    this.setState({
      errors: {},
      errorMessages: {},
      loading: false,
      success: false,
    });
    toggleSignInUpModal();
    setSigninupModalAllFieldsRequired(false);
    // if (!userData && !authInProgress) {
    //   push('/')
    // }
  }

  submitLogin = (e) => {
    const {
      signinupModalAllFieldsRequired,
      gewinnSpielAnswer,
    } = this.props;
    e.preventDefault();
    e.stopPropagation();
    const errors = {};
    this.setState({
      errors,
    });

    if (!this.loginUsername.element.value) errors.loginUsername = true;
    if (!this.loginPassword.element.value) errors.loginPassword = true;

    if (Object.keys(errors).length <= 0) {
      const intents = [];

      if (signinupModalAllFieldsRequired) {
        intents.push('gewinnspiel');
      }

      API.auth(
        this.loginUsername.element.value,
        this.loginPassword.element.value,
        intents,
      ).then((_response) => {
        const { success } = _response;
        this.setState({
          loading: false,
        });

        if (success) {
          if (gewinnSpielAnswer) {
            API.addSweetGreeting({ text: gewinnSpielAnswer });
          }
          analyticsTracker.init().trackEvent('anmeldung', 'submit');
          this.onClose();
        } else {
          this.setLoginErrorShown(true, () => {
            this._toolTipTimeout = setTimeout(() => {
              this.setLoginErrorShown(false);

              clearTimeout(this._toolTipTimeout);
            }, 4 * 1000);
          });
        }
      });

      this.setState({
        loading: true,
      });
    } else {
      this.setState({
        errors,
      });
    }
  }

  submitSignup = e => {
    e.preventDefault();

    const { isRegisterSubmitLoading } = this.state;

    if (isRegisterSubmitLoading) {
      return;
    }

    const {
      signinupModalAllFieldsRequired,
      gewinnSpielAnswer,
      // setGewinnSpielAnswer,
    } = this.props;

    this.setState({
      errors: {},
      errorMessages: {},
      isRegisterSubmitLoading: true,
    }, () => {
      const isPassValid =
        this.state.has8Chars &&
        this.state.hasOneUpperChar &&
        this.state.hasOneLowerChar &&
        this.state.hasNumber &&
        this.state.hasNoSpecialChars;

      if (!this.signupEmail.element.value) this.putError('signupEmail', this.props.errorMessages.error_mandatory_field);
      if (!this.signupUsername.element.value) this.putError('signupUsername', this.props.errorMessages.error_mandatory_field);
      if (!isPassValid) this.putError('signupPassword', 'Bitte geben Sie ein gültiges Passwort ein.');
      if (!this.signupPassword.element.value) this.putError('signupPassword', this.props.errorMessages.error_mandatory_field);
      if (!this.signupPasswordRepeat.element.value) this.putError('signupPasswordRepeat', this.props.errorMessages.error_mandatory_field);
      if (this.signupPassword.element.value !== this.signupPasswordRepeat.element.value) this.putError('signupPassword', this.props.errorMessages.error_password_not_matching);
      if (!this.signupTerms.checked) this.putError('signupTerms', this.props.errorMessages.error_terms_not_accepted);

      // if (false) {
      //   if (
      //     !(
      //       this.signupFirstname.element.value &&
      //       this.signupLastname.element.value &&
      //       this.signupStreet.element.value &&
      //       this.signupStreetnumber.element.value &&
      //       this.signupPostcode.element.value &&
      //       this.signupCity.element.value &&
      //       this.signupCountry.element.value
      //     )
      //   ) {
      //     this.putError('additionalMessages', 'Bitte geben Sie freiwillige Informationen an');
      //   }
      // }

      if (Object.keys(this.state.errors).length <= 0) {
        const data = {
          email: this.signupEmail.element.value,
          username: this.signupUsername.element.value,
          password: this.signupPassword.element.value,
          firstname: this.signupFirstname.element.value,
          lastname: this.signupLastname.element.value,
          street: this.signupStreet.element.value,
          streetnumber: this.signupStreetnumber.element.value,
          postcode: this.signupPostcode.element.value,
          city: this.signupCity.element.value,
          country: this.signupCountry.element.value,
          invitation_token: this.props.invitationToken,
        };
        if (gewinnSpielAnswer) {
          data.sweetGreetings = gewinnSpielAnswer;
        }
        const intents = [];
        if (signinupModalAllFieldsRequired) {
          intents.push('gewinnspiel');
        }

        API.register(data, intents).then((_response) => {
          if (_response.success) {
            // setGewinnSpielAnswer(null)
            if (this.signUpNewsletter.checked) {
              const sendInBlueFormURL = 'https://9afda347.sibforms.com/serve/MUIEAD-1x_XTSbx6MYqtDvbC6M-X9YSlCwAuE1qoDTehzqv3haddZoS5A55NVqWLw5Yc4b7f85DCJk57pRBbr6Z4JuiMGT8NlPX8__wm3x1XZ6MS4F603AGyka9JWZOSdx2iT92S7o4ye7OlVilwceZo9FgOZYm5uv5jgHmJIDetjGfoDbMaZYUCEoB0Uy7LVagf9V0njAdgoUx5?isAjax=1';
              const formData = new FormData();
              formData.append('EMAIL', this.signupEmail.element.value);
              if (this.signupFirstname.element.value) {
                formData.append('VORNAME', this.signupFirstname.element.value);
              }
              if (this.signupLastname.element.value) {
                formData.append('NAME', this.signupLastname.element.value);
              }
              formData.append('OPT_IN', '1');
              fetch(sendInBlueFormURL, {
                method: 'POST',
                body: formData,
              });
            }

            this.setState({
              success: true,
              isRegisterSubmitLoading: false,
            });
            analyticsTracker.init().trackFbEvent('CompleteRegistration');
            analyticsTracker.init().trackEvent('registrierung', 'submit');
            analyticsTracker.init().trackPinterestEvent('signup');
          } else {
            if (_response.errors) {
              this.setState({ isRegisterSubmitLoading: false });
              for (const field in _response.errors) {
                if (_response.errors[field] === true) {
                  this.putError(field, this.props.errorMessages.error_general_form_error);
                } else {
                  this.putError(field, this.props.errorMessages[_response.errors[field]]);
                }
              }
            }
          }
        });
      } else {
        this.setState({
          success: false,
          isRegisterSubmitLoading: false,
        });
      }
    });
  }

  putError = (field, message) => {
    const _errors = this.state.errors;
    const _errorMessages = this.state.errorMessages;

    _errors[field] = true;
    _errorMessages[field] = message;

    this.setState({
      errors: _errors,
      errorMessages: _errorMessages,
    });
  }

  render() {
    const {
      signUpOverlayActiveSection,
      open,
      togglePasswordModal,
      invitationToken,
      setSignUpOverlayActiveSection,
      signinupModalAllFieldsRequired,
    } = this.props;

    const {
      referrerUsername,
      loginErrorShown,
      isRegisterSubmitLoading,
      screenWidth,
      registerAdditionalInfoSectionHeight,
      registerAdditionalInfoSectionOpen,
    } = this.state;

    const loginView = (
      <div className="SignInUpOverlay--main-section">
        {screenWidth > MOBILE_BREAKPOINT && (
          <div
            className="SignInUpOverlay--bm-logo"
            style={{
              backgroundImage: `url(${iconLogo})`,
            }}
          />
        )}
        {
          Bootstrap.getHasLoggedIn()
            ? (
              <Fragment>
                <Headline
                  isBig
                >
                  Willkommen zurück!
                </Headline>
                <h6
                  className="SignInUpOverlay--register-view-subheadline"
                  style={{ marginTop: '-37px', marginBottom: '40px' }}
                >
                  Melde dich hier an.
                </h6>
              </Fragment>
              )
            : (
              <Headline
                isBig
              >
                Bitte melde dich hier an
              </Headline>
              )
        }
        <form className="SignInUpOverlay--form">
          <Label>
            <Input data-error={this.state.errors.loginUsername} ref={(el) => { this.loginUsername = el; }} data-noshadow="true" data-lowercase="true" data-block="true" data-dark="true" type="text" placeholder="E-Mail / Benutzername" />
            {this.state.errors.loginUsername && (
              <FormErrorMessage>{this.state.errorMessages.loginUsername}</FormErrorMessage>
            )}
          </Label>

          <Label>
            <Input data-error={this.state.errors.loginPassword} ref={(el) => { this.loginPassword = el; }} data-noshadow="true" data-lowercase="true" data-block="true" data-dark="true" type="password" placeholder="Passwort"/>
            {this.state.errors.loginPassword && (
              <FormErrorMessage>{this.state.errorMessages.loginPassword}</FormErrorMessage>
            )}
          </Label>

          <div className="SignInUpOverlay--form-footer">

            {screenWidth > MOBILE_BREAKPOINT && (
              <a
                className="SignInUpOverlay--form-resetPassword"
                onClick={togglePasswordModal}
              >
                Passwort vergessen?
              </a>
            )}

            <ConfirmActionButton
              submitAction={this.submitLogin}
              label="Anmelden"
              isLoading={isRegisterSubmitLoading}
              isRed={false}
            />

            {screenWidth < MOBILE_BREAKPOINT && (
              <a
                className="SignInUpOverlay--form-resetPassword"
                onClick={togglePasswordModal}
              >
                Passwort vergessen?
              </a>
            )}

            <InputTooltip
              style={{
                position: 'relative',
                margin: '1rem 0 -2rem 0',
              }}
              shown={loginErrorShown}
              setShown={this.setLoginErrorShown}
              message="Username/E-Mail und/oder Passwort falsch. Bitte überprüfe deine Angaben. Falls du noch kein Konto bei backmomente.de hast, registriere dich einfach, schnell und kostenlos."
            />

          </div>
        </form>
      </div>
    );

    const registerView = (
      <div className="SignInUpOverlay--main-section">
        <Headline
          isBig
          className="SignInUpOverlay--register-view-headline"
        >
          Du hast noch kein Konto?
        </Headline>
        <h6
          className="SignInUpOverlay--register-view-subheadline"
        >
          Registriere dich hier.
        </h6>
        {
          invitationToken && (
            <p className="text-center text-padded-top-bottom SignInUpOverlay--inv-token-line-1">
              Wir freuen uns über dein Interesse! Nutze jetzt deinen persönlichen <br /> Empfehlungslink von &ldquo;<span className="SignInUpOverlay--highlight">{referrerUsername}</span>&rdquo; für Deutschlands größte Back-community!
            </p>
          )
        }

        {
          invitationToken && (
            <p className="text-center text-padded-top-bottom SignInUpOverlay--inv-token-line-1">
              Melde dich jetzt an, bestätige deine Anmeldung via E-Mail und leg direkt los!
            </p>
          )
        }

        <div className="row SignInUpOverlay--registerBox">

          <div className="col-md-6 SignInUpOverlay--registerInfo">
            <h3 className="SignInUpOverlay--formtitle">
              <div className="SignInUpOverlay--formsubtitle">
                Pflichtangabe
              </div>
            </h3>

            <Label>
              <Input data-error={this.state.errors.signupEmail} ref={(el) => { this.signupEmail = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="E-Mail" />
              {this.state.errors.signupEmail && (
                <FormErrorMessage>{this.state.errorMessages.signupEmail}</FormErrorMessage>
              )}
            </Label>

            <Label>
              <Input
                data-error={this.state.errors.signupUsername || this.state.errors.signupUsernameNotValid}
                ref={(el) => { this.signupUsername = el; }}
                data-noshadow="true"
                data-lowercase="true"
                data-block="true"
                type="text"
                placeholder="Nutzername"
                onChange={({ nativeEvent: { target: { value } } }) => {
                  if (value.length && !(/^[a-z0-9 @-_.]+$/).test(value)) {
                    this.putError('signupUsernameNotValid', 'Dieser Nutzername ist ungültig. Umlaute und Sonderzeichen dürfen im Nutzernamen nicht verwendet werden. Bitte prüfe deine Eingabe.');
                  } else {
                    const newErrorMessages = { ...this.state.errorMessages };
                    delete newErrorMessages.signupUsernameNotValid;
                    this.setState({ errorMessages: newErrorMessages });
                  }
                }}
              />
              {this.state.errors.signupUsername && (
                <FormErrorMessage>{this.state.errorMessages.signupUsername}</FormErrorMessage>
              )}
              {this.state.errors.signupUsernameNotValid && (
                <FormErrorMessage>{this.state.errorMessages.signupUsernameNotValid}</FormErrorMessage>
              )}
            </Label>

            <Label>
              <Input
                ref={(el) => { this.signupPassword = el; }}
                data-error={this.state.errors.signupPassword}
                data-noshadow="true"
                data-lowercase="true"
                data-block="true"
                type="password"
                placeholder="Passwort"
                onChange={({ nativeEvent: { target: { value: password } } }) => {
                  const splittedPassword = password.split('');
                  const specialCharsRegExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
                  this.setState({
                    hasInputedPassword: true,
                    has8Chars: password.length >= 8,
                    hasOneUpperChar: splittedPassword.find(char => !parseInt(char, 10) && char === char.toUpperCase()),
                    hasOneLowerChar: splittedPassword.find(char => !parseInt(char, 10) && char === char.toLowerCase()),
                    hasNumber: splittedPassword.find(char => parseInt(char, 10)),
                    hasNoSpecialChars: password !== '' && !specialCharsRegExp.test(password),
                  });
                }}
              />
              <ul
                className="SignInUpOverlay--password-rules"
                style={{
                  height: this.state.hasInputedPassword ? '133px' : '0px',
                  padding: this.state.hasInputedPassword ? '14px 0 10px 0' : '0',
                }}>
                <li>
                  Mindestens 8 Zeichen:
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                      fill={this.state.has8Chars ? '#3aaa35' : '#c8392e'}
                      d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                    />
                  </svg>
                </li>
                <li>
                  Mindestens einen Großbuchstaben:
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                      fill={this.state.hasOneUpperChar ? '#3aaa35' : '#c8392e'}
                      d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                    />
                  </svg>
                </li>
                <li>
                  Mindestens einen Kleinbuchstaben:
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                      fill={this.state.hasOneLowerChar ? '#3aaa35' : '#c8392e'}
                      d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                    />
                  </svg>
                </li>
                <li>
                  Mindestens eine Nummer:
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                      fill={this.state.hasNumber ? '#3aaa35' : '#c8392e'}
                      d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                    />
                  </svg>
                </li>
                <li>
                  Keine Sonderzeichen:
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                      fill={this.state.hasNoSpecialChars ? '#3aaa35' : '#c8392e'}
                      d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                    />
                  </svg>
                </li>
              </ul>
              {this.state.errors.signupPassword && (
                <FormErrorMessage>{this.state.errorMessages.signupPassword}</FormErrorMessage>
              )}
            </Label>

            <Label>
              <Input data-error={this.state.errors.signupPasswordRepeat} ref={(el) => { this.signupPasswordRepeat = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="password" placeholder="Passwortbestätigung"/>
              {this.state.errors.signupPasswordRepeat && (
                <FormErrorMessage>{this.state.errorMessages.signupPasswordRepeat}</FormErrorMessage>
              )}
            </Label>
          </div>

          <div className="col-md-6 SignInUpOverlay--registerMetaInfo">
            <h3
              className={cx('SignInUpOverlay--formtitle', {
                'SignInUpOverlay--formtitle-isOpen': registerAdditionalInfoSectionOpen,
              })}
              onClick={() => this.setState({ registerAdditionalInfoSectionOpen: !registerAdditionalInfoSectionOpen })}
            >
              <div className="SignInUpOverlay--formsubtitle">
                {signinupModalAllFieldsRequired ? <span>Weitere Angaben</span> : <span>Freiwillige Angaben</span>}
              </div>
              <small>(Für Gewinnspiele)</small>
              <div
                className="SignInUpOverlay--registerMetaInfo-toggle"
              >
                <svg
                  version="1.1"
                  viewBox="0 0 64 64"
                  xmlSpace="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink">
                  <polyline
                    fill="#904b27"
                    transform="translate(237.000000, 335.000000)"
                    points="-218.7,-308.6 -216.7,-310.6 -205,-298.8 -193.3,-310.6 -191.3,-308.6 -205,-294.9      -218.7,-308.6    "
                  />
                </svg>
              </div>
            </h3>

            <Measure
              bounds
              onResize={({ bounds: { height } }) => {
                if (registerAdditionalInfoSectionHeight === null) {
                  this.setState({ registerAdditionalInfoSectionHeight: height });
                }
              }}
            >
              {({ measureRef }) => (
                <div
                  ref={measureRef}
                  className="SignInUpOverlay--registerMetaInfo-wrapper"
                  style={{
                    height: screenWidth < REGISTER_BOX_COLLAPSE_BREAKPOINT
                      ? registerAdditionalInfoSectionHeight === null ? 'auto' : `${registerAdditionalInfoSectionOpen ? registerAdditionalInfoSectionHeight : 0}px`
                      : 'auto',
                  }}
                >
                  <Label>
                    <Input ref={(el) => { this.signupFirstname = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Vorname" />
                  </Label>

                  <Label>
                    <Input ref={(el) => { this.signupLastname = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Nachname" />
                  </Label>

                  <div className="SignInUpOverlay--houseInfo">
                    <Label>
                      <Input ref={(el) => { this.signupStreet = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Straße" />
                    </Label>
                    <Label>
                      <Input ref={(el) => { this.signupStreetnumber = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Nr." />
                    </Label>
                  </div>

                  <Label>
                    <Input ref={(el) => { this.signupPostcode = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Postleitzahl" />
                  </Label>

                  <Label>
                    <Input ref={(el) => { this.signupCity = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Stadt" />
                  </Label>

                  <Label>
                    <Input ref={(el) => { this.signupCountry = el; }} data-noshadow="true" data-lowercase="true" data-block="true" type="text" placeholder="Land" />
                  </Label>
                  <FormErrorMessage>{this.state.errorMessages.additionalMessages}</FormErrorMessage>
                </div>
              )}
            </Measure>
          </div>
        </div>

        <label
          className="SignInUpOverlay--confirmSignupTermsContainer"
          data-error={this.state.errors.signupTerms}>
          <div className="SignInUpOverlay--confirmSignup">
            <input ref={(el) => { this.signupTerms = el; }} type="checkbox" />
            <span>
              Hiermit bestätige ich die geltenden&nbsp;
              <a
                href="https://www.backmomente.de/seite/agb"
                target="_blank"
                rel="noopener noreferrer"
              >
                AGB
              </a>
              &nbsp;
              und
              &nbsp;
              <a
                href="https://www.backmomente.de/seite/datenschutz"
                target="_blank"
                rel="noopener noreferrer"
              >
                Datenschutzbedingungen
              </a>
              &nbsp;
              sowie die jeweils für die einzelnen Aktionen geltenden Teilnahmebedingungen, sofern ich an diesen teilnehme.
            </span>
          </div>
          <div className="SignInUpOverlay--confirmSignup">
            <input
              ref={(el) => { this.signUpNewsletter = el; }}
              type="checkbox"
              name="newsletter-agreement"
            />
            <label
              htmlFor="newsletter-agreement"
              style={{ textAlign: 'left', lineHeight: 'normal' }}
            >
              Ich möchte gerne die neuesten Aktionen und Informationen zum Thema Backen in Form des Backmomente.de-Newsletters per E-Mail erhalten. Die Einwilligung kann jederzeit widerrufen werden. Mehr Informationen dazu finden sich <a href="https://www.backmomente.de/seite/datenschutz">hier</a>.
            </label>
            {/* <span>Ich habe die &nbsp;</span>
            <a href={this.props.miscSettings && this.props.miscSettings.terms_url} target="_blank">Allgemeinen Geschäftsbedingungen</a>
            <span>&nbsp; verstanden und stimme diesen zu.</span> */}
          </div>
          {this.state.errors.signupTerms && (
            <FormErrorMessage>{this.state.errorMessages.signupTerms}</FormErrorMessage>
          )}
        </label>

        <div className={cx('SignInUpOverlay--form-footer', 'register-footer', {
        })}>
          <ConfirmActionButton
            submitAction={this.submitSignup}
            label={'Registrieren'}
            isLoading={isRegisterSubmitLoading}
            isRed={false}
          />
        </div>
      </div>
    );

    const successView = (
      <div className="SignInUpOverlay--success">
        <Headline isBig>Geschafft!</Headline>
        <p>
          Du hast dich erfolgreich registriert und musst nur noch den Bestätigungslink klicken, den wir dir per E-Mail zugesandt haben. Danach kannst du direkt eigene Rezepte hochladen.
        </p>
        <br />
        <p>
          <strong>
            Falls du keine Bestätigungsmail von uns erhältst, überprüfe bitte deinem SPAM-Ordner und passe gegebenenfalls deine Filtereinstellungen an.
          </strong>
        </p>
        <div className="SignInUpOverlay--ok-btn">
          <ButtonDistorted
            data-large="true"
            data-block="true"
            isBrown
            onClick={this.onClose}
          >
            OK
          </ButtonDistorted>
        </div>
      </div>
    );

    const mainView = (
      <Layout>
        <div className="row">

          <div className="col-lg-8">
            <main
              className={cx('SignInUpOverlay--main', {
                'SignInUpOverlay--isLogin': screenWidth > MOBILE_BREAKPOINT && signUpOverlayActiveSection === 'login',
              })}
            >
              <div className="SignInUpOverlay--main-partial SignInUpOverlay--register-main">
                {screenWidth > MOBILE_BREAKPOINT ? registerView : loginView}
              </div>
              <div className="SignInUpOverlay--main-partial SignInUpOverlay--login-main">
                {screenWidth > MOBILE_BREAKPOINT ? loginView : registerView}
              </div>
            </main>
          </div>
          <div className="col-md-4 SignInUpOverlay--aside-wrapper">
            <aside
              className={cx('SignInUpOverlay--aside', {
                'SignInUpOverlay--isLogin': screenWidth > MOBILE_BREAKPOINT && signUpOverlayActiveSection === 'login',
              })}
            >
              <div className="SignInUpOverlay--aside-partial SignInUpOverlay--login-aside">
                <div className="SignInUpOverlay--aside-section">
                  {/* <div
                    className="SignInUpOverlay--section-icon SignInUpOverlay--section-icon-logo"
                    style={{ backgroundImage: `url(${iconMuffin})`, backgroundSize: 'contain' }}
                  /> */}
                  <div
                    className="SignInUpOverlay--bm-logo"
                    style={{
                      backgroundImage: `url(${iconLogo})`,
                    }}
                  />
                  <Headline isBig className="SignInUpOverlay--aside-headline">
                    Willkommen zurück!
                  </Headline>
                  <p className="SignInUpOverlay--desc-text">Melde dich hier an.</p>
                  <Button
                    data-large="true"
                    data-block="true"
                    isBrown
                    onClick={() => screenWidth > MOBILE_BREAKPOINT && setSignUpOverlayActiveSection('login')}
                  >
                    Anmelden
                  </Button>
                </div>
              </div>
              <div className="SignInUpOverlay--aside-partial SignInUpOverlay--register-aside">
                <div className="SignInUpOverlay--aside-section">
                  <div
                    className="SignInUpOverlay--section-icon"
                    style={{ backgroundImage: `url(${iconReport})` }}
                  />
                  <Headline
                    isBig
                    className="SignInUpOverlay--aside-headline"
                  >
                    Du hast noch kein Konto?
                  </Headline>
                  <p
                    className="SignInUpOverlay--desc-text"
                  >
                    Registriere dich hier.
                  </p>
                  <Button
                    data-large="true"
                    data-block="true"
                    isBrown
                    onClick={() => screenWidth > MOBILE_BREAKPOINT && setSignUpOverlayActiveSection('register')}
                  >
                    Registrieren
                  </Button>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </Layout>
    );

    return (
      <Modal
        isOpen={open}
        className="SignInUpOverlay"
        onRequestClose={this.onClose}
      >
        {!this.state.success && <ModalCloseButton style={{ top: '20px' }} onClick={this.onClose}/>}

        <div className="SignInUpOverlay--inner">
          {this.state.success ? successView : mainView}
        </div>
      </Modal>
    );
  }
}

export default SignInUpOverlay;
